import uuidv4 from 'uuid/v4';
import delve from 'delve';
import ajaxAppender from './appender/ajax';
import consoleAppender from './appender/console';

export default class Logger {
  constructor(appConfig) {
    this.appenders = [];

    if (appConfig.loggingService.enableConsole) {
      this.addAppender(consoleAppender);
    }

    if (appConfig.loggingService.enableRemoteLogging) {
      this.addAppender(ajaxAppender);
    }

    this.url = appConfig.loggingService.url;
    this.authToken = null;

    this.config = {
      app: 'vac-cards-web',
      api: 'vac-cards-web',
      session: uuidv4(),
    };
  }

  addAppender(appender) {
    this.appenders.push(appender);
  }

  log(level, eventName, message, response, error, method) {
    const messageDetail = typeof message === 'string' ? { message } : message;

    const logEvent = {
      timestamp: new Date().toISOString(),
      level,
      event: eventName,
      method,
      ...messageDetail,
      ...this.config,
    };

    if (response) {
      const responseObj = response.response || response;

      logEvent.url = delve(responseObj, 'config.url');
      logEvent.statusCode = delve(responseObj, 'status');
      logEvent.duration = delve(responseObj, 'config.time.duration');
      logEvent.haystackTraceId = delve(responseObj, 'config.headers.trace-id');

      if (delve(responseObj, 'config.logResponseBody') === true) {
        logEvent.responseBody = delve(responseObj, 'data');
      }
    }

    if (error) {
      logEvent.stackTrace = error.stack;
    }

    this.appenders.forEach((appender) => {
      appender(logEvent, this.authToken, this.url);
    });
  }

  info(eventName, message, response, error, method) {
    this.log('INFO', eventName, message, response, error, method);
  }

  error(eventName, message, response, error, method) {
    this.log('ERROR', eventName, message, response, error, method);
  }

  warn(eventName, message, response, error, method) {
    this.log('WARN', eventName, message, response, error, method);
  }

  debug(eventName, message, response, error, method) {
    this.log('DEBUG', eventName, message, response, error, method);
  }

  setConversationId(conversationId) {
    this.config.conversationId = conversationId;
  }

  setChannelOriginId(channelOriginId) {
    this.config.channelOriginId = channelOriginId;
  }

  setAuthToken(token) {
    this.authToken = token;
  }
}
